import { NavLink, Outlet } from 'react-router';
import { useSession } from '../lib/session.js';

/* ============================================================================
   The frame every logged-in screen sits in.
   ----------------------------------------------------------------------------
   A bottom bar, not a sidebar. This surface is opened on a phone essentially
   every time — a client checking whether their site is ready, standing in
   their shop — and the bottom of a phone screen is the part a thumb reaches
   without moving the hand holding it.

   `bare` drops the navigation for the payment result screens: someone who has
   just been redirected back from Razorpay is mid-transaction, and four tabs is
   an invitation to wander off before reading what happened.
   ========================================================================== */

const TABS = [
  { to: '/', label: 'Project', end: true },
  { to: '/invoices', label: 'Bills', end: false },
  { to: '/edit-requests', label: 'Changes', end: false },
  { to: '/profile', label: 'Aap', end: false },
];

export function Shell({ bare = false }: { bare?: boolean }) {
  const { client } = useSession();

  return (
    <div className={bare ? 'shell shell--bare' : 'shell'}>
      <header className="shell__head">
        <span className="shell__brand">makeyoursite.in</span>
        {client ? <span className="shell__who">{client.business}</span> : null}
      </header>

      <main className="shell__main">
        <Outlet />
      </main>

      {bare ? null : (
        <nav className="tabs" aria-label="Portal">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              to={tab.to}
              end={tab.end}
              className={({ isActive }) => (isActive ? 'tabs__tab tabs__tab--on' : 'tabs__tab')}
            >
              {tab.label}
            </NavLink>
          ))}
        </nav>
      )}
    </div>
  );
}
